import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import ActionCreator from "../ActionCreator";
import Image from "./ImageBackground";

class HotSaleItem extends Component {
  render() {
    let { item, css, navActions } = this.props;

    return (
      <Wrapper
        css={css}
        onClick={() => navActions.push(`/product/?id=${item.id}`)}
      >
        <Image
          src={item.image}
          css={`
            margin-bottom: 10px;
            border-radius: 10px;
            height: 275px;

            @media screen and (max-width: 1200px) {
              margin-bottom: 4px;
              height: 186px;
            }
          `}
          onClick={() => 0}
        />
        <Text
          css={`
            margin-bottom: 6px;
            @media screen and (max-width: 1200px) {
              margin-bottom: 4px;
            }
          `}
        >
          {item.store && item.store.name}
        </Text>
        <Text
          css={`
            margin-bottom: 18px;
            @media screen and (max-width: 1200px) {
              margin-bottom: 4px;
            }
          `}
        >
          {this._limitWords(item.name)}
        </Text>
        <Text>$ {item.price}</Text>
      </Wrapper>
    );
  }

  _limitWords = text => {
    if (text.length >= 14) {
      text = text.slice(0, 12) + "...";
    }

    return text;
  };
}

const Wrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 5px 20px 1px rgba(0, 0, 0, 0.15);
  padding: 10px;

  width: 100%;
  height: 100%;
  cursor: pointer;

  :active {
    position: relative;
    top: 1px;
    left: 1px;
  }

  @media screen and (max-width: 1200px) {
    padding: 6px;
  }

  ${props => props.css || ""};
`;

const Text = styled.div`
  text-align: center;
  font-size: 14px;
  color: #4e4e4e;
  letter-spacing: 0.4px;
  line-height: 20px;
  ${props => props.css || ""};
`;

export default connect(
  null,
  ActionCreator
)(HotSaleItem);
